import { LandingPageLayout } from 'Layouts/LandingPageLayout';
import React from 'react';
import { EchoJumbotron } from './Components/EchoJumbotron';

export const Echo = () => {
	return(
		<LandingPageLayout JumbotronSection={<EchoJumbotron />} isBusiness linkColorMode='black'>

		</LandingPageLayout>
	);
};